import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useCurrencyFormatter from '@swf/core/hooks/useCurrencyFormatter';
import useRequest from '@swf/core/hooks/useRequest';
import { select } from '@swf/core/store';
import { required } from '@swf/core/utils/validators';

import { formatLimitOptions } from '../../../../utils/cashier';
import { getDefaultCurrency } from '../../../../utils/responsibleGamingLimits';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import CurrencyLimit from '../../../CurrencyLimit/CurrencyLimit';

import {
  TXTCLI_Set_Automatic_Withdrawal_Limit,
  TXTWCL_All_winnings_above_this_limit__ELL,
  TXTWCL_Responsible_Gaming_Limits,
  TXTWCL_You_have_to_set_this_limit_due_ELL,
  TXTWCL_You_need_to_select_an_amount_t_ELL
} from './RMFAutomaticWithdrawalLimit.messages.json';

const RMFAutomaticWithdrawalLimit: React.FC = () => {
  const request = useRequest();
  const formatAsCurrency = useCurrencyFormatter();
  const site = useSelector(select.cms.getSiteId);
  const [options, setOptions] = useState([]);
  const [spendingLimit, setSpendingLimit] = useState();

  useEffect(() => {
    request({ service: 'responsiblegaming.balancelimit' }).subscribe(
      ({ body: { spendingLimit, limitOptions } }) => {
        setSpendingLimit(spendingLimit);
        setOptions(limitOptions?.reverse());
      }
    );
  }, [request]);

  return (
    <Container
      page={RMFAutomaticWithdrawalLimit}
      headerProps={{
        title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />
      }}
      pageTopTitle={<Translation {...TXTCLI_Set_Automatic_Withdrawal_Limit} />}
      pageTopSubtitle={
        <>
          <Translation {...TXTWCL_All_winnings_above_this_limit__ELL} />{' '}
          <Translation {...TXTWCL_You_have_to_set_this_limit_due_ELL} />
        </>
      }
    >
      <CurrencyLimit
        id="rmf.withdrawLimit"
        label="Withdrawal Limit"
        options={formatLimitOptions(getDefaultCurrency(site), options, formatAsCurrency)}
        initialFieldValue={spendingLimit}
        validators={[required(TXTWCL_You_need_to_select_an_amount_t_ELL)]}
        hideLabel
      />
      <CTAButton />
    </Container>
  );
};

RMFAutomaticWithdrawalLimit.displayName = 'RMFAutomaticWithdrawalLimit';

export default RMFAutomaticWithdrawalLimit;
